// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const Chrome = window.chrome as const;
